import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../../services/vernost-service.service";

@Component({
  selector: "app-audit-log",
  templateUrl: "./audit-log.component.html",
  styleUrls: ["./audit-log.component.css"]
})
export class AuditLogComponent implements OnInit {
  actionmode: string = "Seacrh";
  showlogArray = false;
  indx = 0;
  loader = false;
  hideTable = false;
  showList: boolean = false;
  hide2Fields = false;
  screentitle: string = "Audit Log";
  screen_details: any = [];
  ComponentArray: any = [];
  dispalyLog: any = [];
  someObject: any = {};
  logArray: any = [];
  backend: any = [
    "FareProduct",
    "Master",
    "Manage Booking",
    "Upload Currency",
    "Rate Per Mile",
    "Back End Logs"
  ];
  constructor(private vernostService: VernostServiceService) {}
  AuditArray: any = [];
  ngOnInit() {}

  addForm() {
    this.actionmode = "Add";
    this.showList = false;
    this.hideTable = false;
    this.hide2Fields = false;
  }

  showPopUp(data) {
    data = data + " ";
    var newData = data.split("info [");
    this.logArray = newData;
    this.showlogArray = true;
  }
  searchForm() {
    this.actionmode = "Search";
    this.hideTable = false;
  }
  getComponent() {
    var moduleName = this.screen_details.module;
    if (moduleName == "Backend") {
      this.ComponentArray = this.backend;
    }
  }

  HideFields() {
    var component = this.screen_details.component;
    if (component == "Back End Logs") {
      this.hide2Fields = true;
    } else {
      this.hide2Fields = false;
    }
  }

  searchData() {
    this.loader = true;
    var component = this.screen_details.component;
    if (component == "Back End Logs") {
      component = "Log";
    }
    var from = this.screen_details.from;
    var to = this.screen_details.to;

    var data = { component: component, from: from, to: to };

    this.vernostService.readLog(data).subscribe(response => {
      this.dispalyLog = [];
      this.AuditArray = [];
      this.loader = false;
      // console.log(response[0].msg);
      if (component == "Log") {
        this.hideTable = true;
        this.dispalyLog.push(response[0].msg);
      } else {
        this.AuditArray = response[0].msg;
        console.log(">>>>>>>>>>>>>>>>>>>>>", this.AuditArray.length);
        if (this.AuditArray.length > 0) {
          this.hideTable = true;
          for (let i = 0; i < this.AuditArray.length; i++) {
            if (this.AuditArray[i].length != 0) {
              this.dispalyLog.push(this.AuditArray[i]);
            }
          }
        }
      }
    });
  }
}
